/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-select-panel[_ngcontent-%COMP%]   mat-option.mat-option[_ngcontent-%COMP%]{margin:1rem 0;overflow:visible;line-height:initial;word-wrap:break-word;white-space:pre-wrap}.mat-option-text.mat-option-text[_ngcontent-%COMP%]{white-space:normal}"];
export { styles as styles };
